import { api } from './base';

import { MutationArg } from 'v2/types';
import { SWRKeyValue } from 'v2/types/swr';
import { DailyTaskModel, DailyTaskRequest } from 'v2/types/TaskModel';

const DAILY_TASK_URL = 'admin/user-daily-task';

export const tasksService = {
  getAllDailyTasks(): Promise<DailyTaskModel[]> {
    return api.get(DAILY_TASK_URL).json();
  },

  createDailyTask(_key: string, { arg }: MutationArg<DailyTaskRequest>): Promise<DailyTaskModel> {
    return api.post(DAILY_TASK_URL, { json: arg }).json();
  },

  updateDailyTask([_key, dailyTaskId]: SWRKeyValue, { arg }: MutationArg<DailyTaskRequest>): Promise<DailyTaskModel> {
    return api.put(`${DAILY_TASK_URL}/${dailyTaskId}`, { json: arg }).json();
  },

  deleteDailyTask([_key, dailyTaskId]: SWRKeyValue): Promise<void> {
    return api.delete(`${DAILY_TASK_URL}/${dailyTaskId}`).json();
  },
};
